/**
 * The names of all the stats that can be stored in the save game. These are things the player has done
 * or achieved in the game.
 */
export enum StatNames {
    BlobsPopped = 0,
    OrangePopped,
    GreenPopped,
    BluePopped,

    HighScore,
    HighCombo,

    HighScoreTimed,
    HighClocks,
    HighScoreCountdown,
    HighCountdownSkulls,

    OrangeFruit,
    GreenFruit,
    BlueFruit,
    RainbowFruit,
    YellowFruit,

    BombUsed,

    TotalPlayTime,

    RedFruit,
    RedPopped,
    YellowPopped,

    NormalGamesPlayed,
    TimedGamesPlayed,
    SurvivalGamesPlayed,

    BooleanStore,

    TotalClocksCollected,
    CumulativeScoreNormal,
    CumulativeScoreTimed,
    CumulativeScoreSurvival,

    CumulativeClocks,
    CumulativeCountdownSkulls,

    HighShapeBonus,

    GameRank,
    CurrentRankXp,

    Lucky7,
    ShapeBonusesInRow,
    TutorialGamesPlayed,
    HighestNumberInChain,

    CreditsWatched,
    LastGameSequences,
    TurquoiseFruit,

    RainbowFruitMatches,

    BooleanStore2,
    LongestTimePlayedTimedMode,

    PinkFruit,
    PinkPopped,
    PurpleFruit,
    PurplePopped,

    HighestLevel,
    LastGameScore,
    LastGameCombo,
    LastGameLevel,

    HighScoreEasy,
    EasyGamesPlayed,
    CumulativeScoreEasy,

    TotalGamesPlayed,
    BeatEasyMode,
    BeatNormalMode,

    BeatSkullMode,
    BeatTimedMode,
    HighSequenceBonus,

    HighScoreZen,
    ZenGamesPlayed,
    CumulativeScoreZen,

    MissionsCompleted,
    MissionRewardAmount,

    LastGameModePlayed,
    LastSkulls,
    LastClocks,

    SunriseAchievement,
    NumberShapeBonuses,

    NumberSkullsCollected,
    NumberClocksCollected,

    NumberLevels,
    NumberCoinBlobsPopped,

    NukesUsed,
    FruitSmashersUsed,
    BarriersUsed,
    ClockMagnetsUsed,
    SkullSmashersUsed,

    TNTExploded,
    NumberDiamondsCollected,
    NumberGoldBricksCollected,

    MoonFruit,
    MoonPopped,
    BrownFruit,
    BrownPopped,

    FruitPopped,
    LastShapeBonus,

    TokenRechargeStartTime,

    MushroomBlobsPopped,

    RecentHighScore,
    RecentHighScoreTimestamp,

    RecentHighScoreTimed,
    RecentHighScoreTimedTimestamp,

    RecentHighScoreCountdown,
    RecentHighScoreCountdownTimestamp,

    RecentHighScoreEasy,
    RecentHighScoreEasyTimestamp,

    Mission1BaseIndex,
    Mission1StatIndex,
    Mission1Goal,
    Mission1ValueAtMissionStart,
    Mission1Area,
    Mission1Completed,
    Mission1Valid,
    Mission1Timestamp,

    Mission2BaseIndex,
    Mission2StatIndex,
    Mission2Goal,
    Mission2ValueAtMissionStart,
    Mission2Area,
    Mission2Completed,
    Mission2Valid,
    Mission2Timestamp,

    Mission3BaseIndex,
    Mission3StatIndex,
    Mission3Goal,
    Mission3ValueAtMissionStart,
    Mission3Area,
    Mission3Completed,
    Mission3Valid,
    Mission3Timestamp,

    HistoryHighScore1,
    HistoryHighScore1Timestamp,
    HistoryHighScore2,
    HistoryHighScore2Timestamp,
    HistoryHighScore3,
    HistoryHighScore3Timestamp,
    HistoryHighScore4,
    HistoryHighScore4Timestamp,

    HistoryHighScoreTimed1,
    HistoryHighScoreTimed1Timestamp,
    HistoryHighScoreTimed2,
    HistoryHighScoreTimed2Timestamp,
    HistoryHighScoreTimed3,
    HistoryHighScoreTimed3Timestamp,
    HistoryHighScoreTimed4,
    HistoryHighScoreTimed4Timestamp,

    HistoryHighScoreCountdown1,
    HistoryHighScoreCountdown1Timestamp,
    HistoryHighScoreCountdown2,
    HistoryHighScoreCountdown2Timestamp,
    HistoryHighScoreCountdown3,
    HistoryHighScoreCountdown3Timestamp,
    HistoryHighScoreCountdown4,
    HistoryHighScoreCountdown4Timestamp,

    HistoryHighScoreEasy1,
    HistoryHighScoreEasy1Timestamp,
    HistoryHighScoreEasy2,
    HistoryHighScoreEasy2Timestamp,
    HistoryHighScoreEasy3,
    HistoryHighScoreEasy3Timestamp,
    HistoryHighScoreEasy4,
    HistoryHighScoreEasy4Timestamp,

    RecentHighScoreZen,
    RecentHighScoreZenTimestamp,
    BeatZenMode,
    NumberOfPeopleInvited,
    TurquoisePopped,
    TipManagerCount,
    FruitBrownPopped,

    PleaseRateUsTimestamp,
    AchievementWindupKnight,
    HighestLevelNormal,
    HighestLevelTimed,
    HighestLevelSkull,
    HighestLevelExpert,

    LastGameTimestamp,
    MaxMushroomBlobsPopped,

    HistoryHighScoreZen1,
    HistoryHighScoreZen1Timestamp,
    HistoryHighScoreZen2,
    HistoryHighScoreZen2Timestamp,
    HistoryHighScoreZen3,
    HistoryHighScoreZen3Timestamp,
    HistoryHighScoreZen4,
    HistoryHighScoreZen4Timestamp,

    HighScoreQuickplay,
    QuickplayGamesPlayed,
    CumulativeScoreQuickplay,

    RecentHighScoreQuickplay,
    RecentHighScoreQuickplayTimestamp,
    BeatQuickplayMode,

    HistoryHighScoreQuickplay1,
    HistoryHighScoreQuickplay1Timestamp,
    HistoryHighScoreQuickplay2,
    HistoryHighScoreQuickplay2Timestamp,
    HistoryHighScoreQuickplay3,
    HistoryHighScoreQuickplay3Timestamp,
    HistoryHighScoreQuickplay4,
    HistoryHighScoreQuickplay4Timestamp,

    HighStarsCollected,
    TotalStarsCollected,
    LastStarsCollected,
    LastFruitLeft,

    Version,

    CumulativeScoreAny,
    DailyRewardTimestamp,

    HighScoreFungus,
    FungusGamesPlayed,
    CumulativeScoreFungus,

    HistoryHighScoreFungus1,
    HistoryHighScoreFungus1Timestamp,
    HistoryHighScoreFungus2,
    HistoryHighScoreFungus2Timestamp,
    HistoryHighScoreFungus3,
    HistoryHighScoreFungus3Timestamp,
    HistoryHighScoreFungus4,
    HistoryHighScoreFungus4Timestamp,

    RecentHighScoreFungus,
    RecentHighScoreFungusTimestamp,
    BeatFungusMode,
    MushroomPoppersUsed,
    MushroomsPoppedInMushroomMode,
    HighMushrooms,
    LastMushrooms,

    HistoryHighScoreCupcake1,
    HistoryHighScoreCupcake1Timestamp,
    HistoryHighScoreCupcake2,
    HistoryHighScoreCupcake2Timestamp,
    HistoryHighScoreCupcake3,
    HistoryHighScoreCupcake3Timestamp,
    HistoryHighScoreCupcake4,
    HistoryHighScoreCupcake4Timestamp,
    RecentHighScoreCupcake,
    RecentHighScoreCupcakeTimestamp,
    BeatCupcakeMode,

    HighScoreCupcake,
    CumulativeScoreCupcake,
    LastCupcakes,
    CupcakeGamesPlayed,
    TotalCupcakes,
    HighCupcakes,
    HighestLevelCupcake,
    HighestLevelFungus,

    FacebookEverLoggedIn,
    LastFacebookTipIndex,
    LastHolidayMalwearTimestamp,
    LastNewMalwearTimestamp,

    FreezeDropsUsed,
    FreezeDropGamesPlayed,
    BooleanStore3,
    BooleanStore4,
    BooleanStore5,
}
